module.exports = __webpack_public_path__ + "d24cf0884.jpg";